export const INTERNAL_SERVER_ERROR = 'Error interno del servidor, inténtalo de nuevo más tarde'
export const UNEXPECTED_ERROR = 'Ocurrio un error inesperado, inténtalo de nuevo más tarde'
